import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

import LawsInsideTwo from "./LawsInsideTwo.js";

const content = (
     <span>
          (بند ۵ ماده واحده)
          <br/>
          قانون‌اصلاح‌قانون‌چگونگی‌اداره‌مناطق‌آزادتجاری-صنعتی جمهوری اسلامی ایران
          <br />
          (مصوب ۲۵/۱۲/۱۳۷۷ مجلس شورای اسلامی و۳۰/۴/۱۳۷۸مجمع تشخیص مصلحت نظام)
          <br />
          ماده واحده . قانون چگونگی اداره مناطق آزاد تجاری- صنعتی جمهوری اسلامی ایران - مصوب ۱۳۷۲ به شرح زیر اصلاح می شود :
          <br />
          ۱.....
          <br />
          ۲.....
          <br />
          ۳.....
          <br />
          ۴.....
          <br />
          ۵. متن زیر به عنوان ماده ۲۸ به قانون مذکور الحاق می شود:
          <br />
          ماده ۲۸. تاسیس و فعالیت موسسات بیمه ایرانی با سرمایه داخلی وخارجی و شعب و نمایندگی آنها و موسسات کارگزاری بیمه در مناطق آزاد تجاری-صنعتی جمهوری اسلامی ایران مجاز و صرفاً تابع مقرراتی است که به پیشنهاد بیمه مرکزی ایران به تصویب هیئت وزیران خواهد رسید.
          <br />
          قانون فوق مشتمل بر ماده واحده در جلسه علنی روز سه شنبه مورخ بیست و پنجم اسفند ماه یک هزاروسیصدوهفتادوهفت مجلس شورای اسلامی تصویب و در تاریخ ۳۰/۴/۱۳۷۸ به تصویب نهایی مجمع تشخیص مصلحت نظام رسیده است.
          <br />
          تبصره :حكم مذكور در اين ماده شامل شعب و نمايندگي موسسات خارجي و موسسات كارگزاري بيمه خارجي نيز خواهد بود .
     </span>
);
const SpecificFourInside = props => {
     return props.size === "laptopdesktop" ? (
          <div>
               <LawsInsideTwo title="‌قانون‌ اصلاح‌ قانون‌ چگونگی‌ اداره‌ مناطق‌ آزاد تجاری " text={content} size="laptopdesktop" />
          </div>
     ) : props.size === "tablet" ? (
          <div>
                    <LawsInsideTwo title="‌قانون‌ اصلاح‌ قانون‌ چگونگی‌ اداره‌ مناطق‌ آزاد تجاری " text={content} size="tablet" />
          </div>

     ) : (
                    <div>
                         <LawsInsideTwo title="‌قانون‌ اصلاح‌ قانون‌ چگونگی‌ اداره‌ مناطق‌ آزاد تجاری " text={content} />
                    </div>
               );
};

export default SpecificFourInside;
